import { Builder } from '@builder.io/react';
import { builder } from '@builder.io/react';
import React, { useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';

import ChevronDown from '@videoblocks/react-icons/ChevronDown';

import { Text } from '../../storyblocks-design-system/components/atoms/Text/Text';

const fetchContent = async () => {
  const builderApiResponse = await builder.get('category-search-page');
  if (builderApiResponse?.data) {
    return builderApiResponse.data;
  }
  return {
    data: {
      faqItems: [],
    },
  };
};

const Faq = () => {
  const [items, setItems] = useState([]);
  const [accordion, setAccordion] = useState({});
  useEffect(() => {
    const getClontent = async () => {
      const { faqItems } = await fetchContent();
      setItems(faqItems);
    };
    getClontent();
  }, []);

  const handleOnToggle = (section: string) => {
    setAccordion((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };
  return (
    <div className="font-polysans flex flex-col lg:flex-row w-full gap-8 px-6 py-16 md:py-24 md:px-12 lg:px-24">
      <div className="flex-auto lg:max-w-120 lg:w-full">
        <Text fontFamily="polysans" fontWeight="semibold" fontSize="5xl">
          <>
            <span className="lg:block">Frequently </span>Asked Questions
          </>
        </Text>
      </div>
      <ul className="flex-auto">
        {items.length > 0
          ? items.map(({ faqAnswer, faqQuestion }, index) => (
              <li
                className="flex flex-col gap-2 w-full bg-gray-200 mb-6 p-8 rounded-xl border-gray-300 border-2 cursor-pointer"
                key={`faq_${index}`}
                onClickCapture={() => handleOnToggle(`faq_${index}`)}
              >
                <div className="flex justify-between">
                  <Text
                    fontFamily="polysans"
                    fontSize="2xl"
                    fontWeight="semibold"
                  >
                    {faqQuestion}
                  </Text>
                  <div className="flex flex-none justify-center items-center w-30px h-30px bg-yellow-300 rounded-full border-2 border-blue-900">
                    <ChevronDown
                      className={twMerge(
                        'h-15px w-15px transition duration-200 ease-in',
                        accordion[`faq_${index}`] && 'transform -rotate-180'
                      )}
                    />
                  </div>
                </div>
                <div
                  className={twMerge(
                    accordion[`faq_${index}`] ? 'max-h-1000px' : 'max-h-0',
                    'overflow-hidden transition-max-height duration-200 ease-in-out'
                  )}
                >
                  <Text
                    fontFamily="polysans"
                    fontWeight="regular"
                    fontSize="base"
                  >
                    {faqAnswer}
                  </Text>
                </div>
              </li>
            ))
          : null}
      </ul>
    </div>
  );
};

Builder.registerComponent(Faq, {
  name: 'Faq SB',
  inputs: [],
});
